import React from 'react'

export default function Contact({ profile, t, lang }) {
  return (
    <section className="contact-section" id="contact">
      <div className="container contact-card">
        <div>
          <p className="eyebrow">{t.contact}</p>
          <h2>
            {lang === 'en'
              ? 'Let’s talk about your next project.'
              : 'Hablemos de tu próximo proyecto.'}
          </h2>
          <p>{t.contactText}</p>
        </div>

        <div className="contact-actions">
          <a href={'mailto:' + profile.email}>{profile.email} →</a>

          <a href={profile.linkedin} target="_blank" rel="noreferrer">
            LinkedIn →
          </a>
        </div>
      </div>
    </section>
  )
}
